import react, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { RiFileExcel2Fill } from "react-icons/ri";
import {exportToExcel} from "../../Student/Reusablecomponents/RegularFunctions";
const AssessmentsParticipation = () => {
    const USYear = useSelector((state) => state.SelecYearData.SYear);
    const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const { SetLoad } = useContext(LoadContext);
    const [AssessmenTesType, SetAssessmenTesType] = useState([]);
    const [ATTOptions, SetATTOptions] = useState();
    const [APCounts, SetAPCounts] = useState([]);

    const CurrentAssessmentDetails = async () => {
        SetLoad(true);
        await axios.get(process.env.REACT_APP_API_BASE_URL +
            `/InstitutionAdmin/GetLatestAssessmentsSchedulesbyInstitute?InstituteId=${items?.instituteId}&SocietyId=${items?.societyId}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                if (res.data[0]?.contestCreationId) {
                    GetAssessmentsParticipationcount(res.data[0]?.contestCreationId, res.data[0]?.assessmentType, res.data[0]?.assessmentTypeNo);
                    const FormatData = res.data.map((item) => ({
                        display: `${item?.assessmentTypeName} , ${item?.assessmentDate}`,
                        value: item?.contestCreationId,
                        ...item
                    }))
                    SetAssessmenTesType(FormatData[0]);
                    SetATTOptions(FormatData)
                } else { SetLoad(false); }
            })
            .catch((err) => { console.log(err); });
    }

    const GetAssessmentsParticipationcount = async (CCID, AType, ATNo) => {
        await axios.get(process.env.REACT_APP_API_BASE_URL +
            `/InstitutionAdmin/GetSchoolwiseAsstParticipationbyInstitute?InstituteId=${items?.instituteId}&AssessmentType=${AType}&AssessmentTypeNo=${ATNo}&ContestcreationId=${CCID}&SocietyId=${items?.societyId}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                const Totals = res.data.reduce(
                    (acc, item) => {
                        acc.participationCount += item.participationCount;
                        acc.registeredCount += item.registeredCount;
                        return acc;
                    },
                    {
                        participationCount: 0,
                        registeredCount: 0
                    }
                );
                const Total ={
                    schoolName: "Total",
                    ...Totals
                }
                SetAPCounts([Total,...res.data]);
                SetLoad(false);
            })
            .catch((err) => { console.log(err); });
    }
    useEffect(() => { CurrentAssessmentDetails(); }, [])

    const columns = [
        { name: "School ID", sortable: true, selector: "schoolLoginId", },
        { name: "School Name", sortable: true, selector: "schoolName", },
        { name: "Registered Count", selector: "registeredCount", sortable: true, },
        { name: "Participation Count", selector: "participationCount", sortable: true, },
    ];
    const HandleAssessmentChange = (e) => {
        const SA = ATTOptions.filter((item) => item.value == e.target.value);
        SetAssessmenTesType(SA[0]); 
        SetLoad(true);
        GetAssessmentsParticipationcount(SA?.[0]?.contestCreationId, SA?.[0]?.assessmentType, SA?.[0]?.assessmentTypeNo);
    }
    const DownloadFIle = () => {
              const XL = APCounts?.map((item, index) => {
                  return {
                      "S.No": index + 1,
                      "School ID": item?.schoolLoginId,
                      "School Name": item?.schoolName,
                      "Registered Count": item?.registeredCount,
                      "Participation Count": item?.participationCount,
                  }
              })
              exportToExcel(XL, `${items?.fullName} - Live Assessment Participation Deatils `, false,  "Live Assessment Participation Deatils",`${items?.fullName} - Live Assessment Participation Deatils`, true);
          }
    return (
        <>
            <div className="TeacherBgImage">
                <div className="dflex JSBetween mt-2">
                    <div></div>
                    <div className="MainHeading" style={{position:"relative",left:"10%"}}>Current Assessment Participation</div>
                    <div className="dflex gap-2" >
                    <DropdownValues className="NCLDropdown" options={ATTOptions} onChange={(e) => HandleAssessmentChange(e)} />
                        {ATTOptions?.length >0 &&  <div className="ExportExcel  alignitems gap-2" onClick={()=>{DownloadFIle()}} title="Export to Excel"> <RiFileExcel2Fill />  </div>}
                        </div>
                </div>

                <DataTable className="Card NCLDataTable mt-2" data={APCounts} columns={columns}
                    ShowPagination={true} ShowPagecount={true} Dropdownvalues={["10", "25", "50", "100"]} />
            </div>
        </>
    )
}
export default AssessmentsParticipation;